import { InjectionToken } from '@angular/core';

export const PORTAL_PATIENT_QUICK_VIEW_COMPONENT = new InjectionToken(
  'PortalPatientQuickViewComponent'
);
